"use strict";

const PhotoCapture = function () {
  var bindTriggers = function ($parent) {
    unbindTriggers($parent);

    $parent.on("click", ".js-photo-capture-camera", (e) =>
      triggerInput(e, ".js-photo-capture-camera-input"),
    );
    $parent.on("click", ".js-photo-capture-gallery", (e) =>
      triggerInput(e, ".js-photo-capture-gallery-input"),
    );
  };

  var unbindTriggers = function ($parent) {
    $parent.off("click", ".js-photo-capture-camera");
    $parent.off("click", ".js-photo-capture-gallery");
  };

  var triggerInput = function (e, inputClass) {
    e.preventDefault();
    e.stopPropagation();
    $(e.currentTarget).closest(".photo-capture-group").siblings(inputClass).trigger("click");
  };

  return {
    bindTriggers,
    unbindTriggers,
  };
};

module.exports = PhotoCapture();
